<template>
    <div class="newsdetail_home">
        <div class="nd1">
            <div class="nd1_cont">
                <div class="nd1_left">
                    <!-- <div class="nd1_title">您的位置：首页>艺术资讯>{{ newsData.title }}</div> -->
                    <div class="nd1_left_top">
                        <div class="nd1_time">
                            <p>{{ newsData.create_time }}</p>
                            <p class="slogan">GO FAR WITH RoSSo</p>
                        </div>
                        <div class="nd1_big_title">{{ newsData.title }}</div>
                        <div v-html="newsData.article_content" class="nd1_html_box" @click="imgKefu"></div>
                    </div>
                    <!-- <div class="nd1_foot">
                        <p>*版权声明：本文均属ROSSO艺术留学团队原创，未经允许不能以任何形式 的商业转载，如有发现必追究法律责任。</p>
                        <img src="https://public.rossoarts.com/static/images/saoyisao.gif" alt="">
                        
                    </div> -->
                    

                    <!-- <div class="new_last_box">
                        <img src="../img/newlast1.gif" alt="" style="width: 700px;margin-bottom: 20px;">
                       
                        <img class="sb_img1" src="../img/sbmayanc/sb1.jpg" alt="">
                        <div class="sb_box">
                            <img src="../img/sbmayanc/sb2.png" alt="">
                        <img src="../img/sbmayanc/sb3.png" alt="">
                        </div>
                        <img src="../img/newlast2.jpg" alt="" >
                    </div> -->
                    <img src="../img/newD3.png" alt="" class="nd1_left_foot">

                </div>
                <div class="nd1_right">
                    <div class="nd1_right_top">
                        <p class="p1">在线提问</p>
                        <img src="../img/duo.jpg" alt="">
                        <p class="p2">Duo</p>
                        <p class="p3">专业：服装设计 </p>
                        <p class="p4">院校：伦敦艺术大学</p>
                        <div class="p56_box">
                            <p class="p5">·申请成功率：<span>99%</span></p>
                            <p class="p6">·直录TOP5概率：<span>85%</span></p>
                        </div>
                        <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                            <div class="btn">
                                向老师提问
                            </div>
                        </a>
                    </div>
                    <div class="nd1_right_bottom">
                        <h1>院校推荐</h1>
                        <div class="school_box">
                            <div class="school_item" @click="jopSchoolDetail(1, '帕森斯设计学院')">
                                <img src="../img/ns1.jpg" alt="">
                                <p>帕森斯设计学院</p>
                            </div>
                            <div class="school_item" @click="jopSchoolDetail(3, '罗德岛设计学院')">
                                <img src="../img/ns2.jpg" alt="">
                                <p>罗德岛设计学院</p>
                            </div>
                            <div class="school_item" @click="jopSchoolDetail(4, '伦敦艺术大学')">
                                <img src="../img/ns3.jpg" alt="">
                                <p>伦敦艺术大学</p>
                            </div>
                            <div class="school_item" @click="jopSchoolDetail(5, '皇家艺术学院')">
                                <img src="../img/ns4.jpg" alt="">
                                <p>皇家艺术学院</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import "@/assets/css/newsdetail.css"
export default {
    data() {
        return {
            newsData: []
        }
    },
    created() {
        // console.log(this.$route.params.id.split(".")[0]);
        this.getNewsId(this.$route.params.id.split(".")[0])


        // src= https://public.rossoarts.com/static/upload/image/20230531/1685526489380372.png\ \"/static/upload/image/20230531/1685526489380372.png\
        //      https://public.rossoarts.com/static/upload/image/20230531/1685526351772036.png
        //      https://public.rossoarts.com/static/upload/image/20230531/1685526351772036.png
        //      https://public.rossoarts.com/static/upload/image/202305311685526351772036.png
        //      https://public.rossoarts.com/static/upload/image/20230531/1685526568572994.png
        //      https://public.rossoarts.com/static/upload/image/20230516/1684224394516448.jfif
    },
    filters: {
        schoolSplit(val) {

            console.log(val);
            return val == "" ? "没有了" : val.title

        }
    },
    methods: {
        imgKefu(e) {
            if (e.target.nodeName == 'IMG') { //判断点击富文本内容为img图片
                window.open("https://www11c1.53kf.com/webCompany.php?kf_sign=TM2MzMTY5NIyMTEzMjkwNDY2MTM3MDAyNzIxNjgzNTM=&arg=10168353&style=1&guest_id=13290466137002&language=zh-cn&charset=gbk&referer=http%3A%2F%2Flocalhost%3A8080%2F&keyword=&tpl=crystal_blue&uid=3607747077cad8d4d3b0d8dbd747bc0c&is_group=&timeStamp=1695366605837&ucust_id=", '_blank')
            } 
        },

        jopSchoolDetail(val, val2) {
            // console.log(val,val2);
            // this.$router.push(`/${val}.html?cname=${val2}`)
            this.$router.push({

                path: `/schools/${val}.html?cname=${val2}`,

            })
        },
        getNewsId(val) {
            axios.get(`https://public.rossoarts.com/api/v1/getArtsNew?id=${val}`).then((data) => {
                // console.log(data.data.data);
                this.newsData = data.data.data
                this.$nextTick(() => {
                    // var htmlImg = document.getElementsByClassName("rich_pages wxw-img")
                    var htmlImg = document.getElementsByClassName("nd1_html_box")[0].getElementsByTagName("img")
                    //    console.log(htmlImg[0].src);
                    for (var i = 0; i < htmlImg.length; i++) {
                        // console.log(htmlImg[i].src);
                        htmlImg[i].src = "https://public.rossoarts.com/static/upload/image/" + htmlImg[i].src.split("/")[htmlImg[i].src.split("/").length - 2] + '/' + htmlImg[i].src.split("/")[htmlImg[i].src.split("/").length - 1]
                        // console.log(htmlImg[i].src);
                    }

                })
            })
        },
    }
}
</script>